import React, { useState } from 'react';
import {
  Section,
  Container,
  Heading,
  Subtext,
  Grid,
  PartnerCard,
  Logo,
  PartnerName,
} from './TrustedPartnersElements';
import { TRUSTED_PARTNERS, getLogoUrl } from './partners';

const TrustedPartners = () => {
  const [failedLogos, setFailedLogos] = useState(new Set());

  const handleLogoError = (key) => {
    setFailedLogos((prev) => new Set(prev).add(key));
  };

  const getPartnerLogo = (partner) => {
    if (partner.logo) return partner.logo;
    return getLogoUrl(partner.domain);
  };

  const getPartnerLogoKey = (partner) => partner.logo || partner.domain || partner.name;

  return (
    <Section id="trusted-partners">
      <Container>
        <Heading>Trusted Partners</Heading>
        <Subtext>
          We’re proud to work with brands and businesses that trust Wiry for their digital presence.
        </Subtext>
        <Grid>
          {TRUSTED_PARTNERS.map((partner) => {
            const logoUrl = getPartnerLogo(partner);
            const logoKey = getPartnerLogoKey(partner);
            const showFallback = !logoUrl || failedLogos.has(logoKey);

            return (
              <PartnerCard key={partner.name}>
                {!showFallback ? (
                  <>
                    <Logo
                      src={logoUrl}
                      alt={partner.name}
                      onError={() => handleLogoError(logoKey)}
                      className="color"
                    />
                    <PartnerName>{partner.name}</PartnerName>
                  </>
                ) : (
                  <PartnerName style={{ marginTop: 0, fontSize: '1rem', fontWeight: 600 }}>
                    {partner.name}
                  </PartnerName>
                )}
              </PartnerCard>
            );
          })}
        </Grid>
      </Container>
    </Section>
  );
};

export default TrustedPartners;
